import { call, put, takeEvery } from 'redux-saga/effects';

import { REDUX_STORE } from '@funnels/constants';
import { FetchProductSelectionsAction } from '@funnels/types';
import { datadogUtil } from '@funnels/utils';

import { waitForAuth } from '../_common';
import { fetchProductSelectionsFail, fetchProductSelectionsSuccess } from '../actions';
import ProductSelectionAPI from './api';

export function* fetchProductSelectionsWorker(action: FetchProductSelectionsAction): any {
  try {
    yield waitForAuth();

    const { applicationId } = action;

    let response;
    if (applicationId) {
      response = yield call(ProductSelectionAPI.fetch, applicationId);
    } else {
      throw new Error('No Applicantion Id');
    }

    yield put(fetchProductSelectionsSuccess(response));
  } catch (e: any) {
    datadogUtil.addError(e);
    yield put(fetchProductSelectionsFail(e.response?.data || e.message));
  }
}

export function* productSelectionsWatcher() {
  yield takeEvery(REDUX_STORE.PRODUCT_SELECTIONS.ACTION_TYPES.FETCH_PRODUCT_SELECTIONS, fetchProductSelectionsWorker);
}

export default productSelectionsWatcher;
